import { SystemRefreshLine } from '@m-ui/icons';
import { Button } from 'm-ui';
import React, { FC, useRef, useState } from 'react';
import './index.less';

interface IPreviewIframeProps {
  width?: number;
  height?: number;
  src: string;
}
const PreviewIframe: FC<IPreviewIframeProps> = (props) => {
  const { width = 216, height = 384, src } = props;
  const ifRef = useRef<HTMLDivElement>(null);
  const [mute, setMute] = useState(false);
  const [source, setSource] = useState(src);
  return (
    <div ref={ifRef} className="preview-if">
      <iframe
        title="预览"
        scrolling="no"
        width={width}
        height={height}
        frameBorder="0"
        src={source}
      />
      <div className="text-center" style={{ padding: '20px 0' }}>
        <Button
          size="small"
          icon={<SystemRefreshLine />}
          onClick={() => {
            setSource('');
            setTimeout(() => {
              setSource(src);
            }, 300);
          }}
        >
          刷新
        </Button>
        {/* <Button
          icon={mute ? <NormalMuteLine /> : <NormalSoundLoudLine />}
          style={{ marginLeft: 8 }}
          size="small"
          onClick={() => {
            setMute(!mute);
          }}
        >
          声音
        </Button> */}
      </div>
    </div>
  );
};

export default PreviewIframe;
